import TmpButtonCustom from "../TmpButtonCustom/TmpButtonCustom";
import { ButtonGroup } from "./Style";
import { style } from "./StyleType";

interface TmpButtonGroupCustomProps {
    size: "sm" | "lg";
    idPrimary?: string;
    idSecondary?: string;
    labelPrimary: string;
    labelSecondary: string;
    loadingButtonPrimary?: boolean;
    loadingButtonSecondary?: boolean;
    disabledPrimary?: boolean;
    disabledSecondary?: boolean;
    handleClickPrimary?: () => void;
    handleClickSecondary?: () => void;
}

export default function TmpButtonGroupCustom(props: TmpButtonGroupCustomProps) {

    // Events
    const _handleClick = (type: string) => {
        if (type === "primary") {
            if (props.handleClickPrimary) {
                props.handleClickPrimary();
            }
        }
        if (type === "secondary") {
            if (props.handleClickSecondary) {
                props.handleClickSecondary();
            }
        }
    };


    // Passing style props to styled component
    ButtonGroup.defaultProps = style;

    return (
        <ButtonGroup className="tmp-button-group" role="group">
            <TmpButtonCustom
                id={props.idPrimary}
                type="secondary"
                typeButton="button"
                size={props.size}
                disabled={props.disabledSecondary}
                loading={props.loadingButtonSecondary ? true : false}
                handleClick={() => _handleClick("secondary")}
            >
                {props.labelSecondary}
            </TmpButtonCustom>

            <TmpButtonCustom
                id={props.idSecondary}
                type="primary"
                typeButton="button"
                size={props.size}
                disabled={props.disabledPrimary}
                loading={props.loadingButtonPrimary ? true : false}
                handleClick={() => _handleClick("primary")}
            >
                {props.labelPrimary}
            </TmpButtonCustom>
        </ButtonGroup>
    );

}